import { useCallback, useRef } from 'react';
export const useTimeoutSubscription = () => {
    const timeoutIdRef = useRef(null);
    const cancelTimeout = useCallback(() => {
        const timeoutId = timeoutIdRef.current;
        if (timeoutId) {
            timeoutIdRef.current = null;
            clearTimeout(timeoutId);
        }
    }, [timeoutIdRef]);
    return { timeoutIdRef, cancelTimeout };
};
